@if ({
  product: product$ | async,
  }; as content) {
  <div class="container-contact-our-experts">
    <button type="button" class="btn btn-secondary w-100" (click)="openModalContactOurExperts()">
      <span class="material-symbols-outlined m-r-4"> call </span>
      {{ 'contactOurExperts.label' | cxTranslate }}
    </button>
  </div>
}
